// extracted by mini-css-extract-plugin
module.exports = {"warning":"App_warning__FnicG","pageContainer":"App_pageContainer__3kYYz","content":"App_content__1dlDM","footer":"App_footer__hZfNL","errorContainer":"App_errorContainer__24JQu"};